import "core-js/stable";
import "regenerator-runtime/runtime";

import "./style.scss";

// React dependencies
import React from "react";
import ReactDOM from "react-dom";
// Hot reload for development
import { AppContainer } from "react-hot-loader";
// Translations
import { I18nextProvider } from "react-i18next";

import App from "./App";
import i18n from "./I18n/i18n";
import { makeServer } from "./server";

if (process.env.NODE_ENV === "development") {
  makeServer();
}

const root = document.getElementById("root");

const render = (Component) => {
  ReactDOM.render(
    <AppContainer>
      <I18nextProvider i18n={i18n}>
        <Component />
      </I18nextProvider>
    </AppContainer>,
    root,
  );
};

render(App);

if (module.hot) {
  module.hot.accept("./App", () => {
    render(App);
  });
}

export { render };
